import { graphql } from 'react-apollo';

import { ProgramMembershipsByUserQuery } from 'bundles/enterprise-legacy-learner-home/components/single-program/SingleProgramGraphqlQueries';
import type {
  ProgramMembershipsByUserQuery as ProgramMembershipsByUserQueryData,
  ProgramMembershipsByUserQueryVariables,
} from 'bundles/enterprise-legacy-learner-home/components/single-program/__generated__/ProgramMembershipsByUserQuery';

export type PropsForWithHasMultipleProgramProps = {
  userId: number | string;
  thirdPartyOrganizationId: string;
};

export type PropsFromWithHasMultipleProgramProps = {
  hasMultipleProgramsInOrg?: boolean;
};

const withHasMultipleProgramProps = graphql<
  PropsForWithHasMultipleProgramProps,
  ProgramMembershipsByUserQueryData,
  ProgramMembershipsByUserQueryVariables,
  PropsFromWithHasMultipleProgramProps
>(ProgramMembershipsByUserQuery, {
  skip: ({ userId }) => !userId,
  options: ({ userId }) => ({
    variables: {
      // See above skip().
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      userId: userId!.toString(),
    },
    // Query is executed by the page header, we're just piggy-backing off of it.
    fetchPolicy: 'cache-only',
  }),
  props: ({ data, ownProps: { thirdPartyOrganizationId } }): PropsFromWithHasMultipleProgramProps => {
    const programMemberships = data?.ProgramMembershipsV2Resource?.byUser?.elements;
    const programMembershipsWithinOrg = programMemberships?.filter(
      (programMembership) => programMembership?.enterpriseProgram?.thirdPartyOrganizationId === thirdPartyOrganizationId
    );
    return {
      hasMultipleProgramsInOrg: Number(programMembershipsWithinOrg?.length) > 1,
    };
  },
});

export default withHasMultipleProgramProps;
